import { gql } from '@apollo/client';
import organizationFragment from './organizationFragment';

const GET_ORGANIZATIONS = gql`
  query GetOrganizations($filters: [FilterInput!], $offset: Int, $limit: Int) {
    mddapOrganizationsFiltered(filters: $filters, offset: $offset, limit: $limit) {
      ...OrganizationFields
    }
    mddapOrganizationsFilteredCount(filters: $filters)
  }
  ${organizationFragment}
`;

export default GET_ORGANIZATIONS;
